import { marketData } from '@core/market-data-sdk';
import { SearchOutput, SearchUseCase } from './search-use-case';
import { GeneralSearchUseCase } from './general-search';
import { SearchItemEntity } from './entities/search-item';

export class GeneralSearchWithAdminAndManagersUseCase implements SearchUseCase {
  async execute(term: string): Promise<SearchOutput> {
    const responses = await Promise.all([
      GeneralSearchUseCase.getAssets(term),
      this.getAdmins(term),
      this.getAssetManagers(term),
    ]);

    const [assets, ...rest] = responses;
    const formattedAssets = GeneralSearchUseCase.assetsFormatter(assets);

    const allItems = [...formattedAssets, ...rest.flat()];

    const { categories, groupedAssets } =
      GeneralSearchUseCase.groupAssetsByCategory(allItems);

    const formattedAssetsList = Object.entries(groupedAssets).reduce(
      (acc, [category, list]: any) => {
        return {
          ...acc,
          [category]: list
            .filter((asset: any) => !asset.isDisabled(false))
            .map(
              (asset: any) =>
                ({
                  ...asset.toJson(),
                  url: asset.canonical_url,
                  enable: !asset.isDisabled(false),
                } as any)
            ),
        };
      },
      {}
    );

    return {
      categories: categories,
      groupedAssets: formattedAssetsList,
    } as any;
  }

  private async getAdmins(term: string): Promise<SearchItemEntity[]> {
    try {
      const data = await marketData.administrators.search(term);

      return data.map((admin) => {
        const searchItem = new SearchItemEntity({
          nicename: admin.n,
          identifier: admin.c.toString(),
          type: 'Administrador',
          canonical_url: `/administradores/${admin.s}`,
          additional_fields: {
            has_quotes: true,
            cnpj: admin.c,
          },
        });

        return searchItem;
      });
    } catch (error) {
      return [];
    }
  }

  private async getAssetManagers(term: string): Promise<SearchItemEntity[]> {
    try {
      const data = await marketData.assetManagers.search(term);

      return data.map((manager) => {
        const searchItem = new SearchItemEntity({
          nicename: manager.n,
          identifier: manager.c.toString(),
          type: 'Gestor',
          canonical_url: `/gestores/${manager.s}`,
          additional_fields: {
            has_quotes: true,
            cnpj: manager.c,
          },
        });

        return searchItem;
      });
    } catch (error) {
      return [];
    }
  }
}
